import {Outlet} from "react-router";
import Header from "./header/Header";
import {Container} from "react-bootstrap";
import {SoknaderProvider} from "./soknader/contexts/SoknaderContext";

function Layout(){
    return (
        <>
            <Header></Header>
            <Container className={"mt-4"}>
                <SoknaderProvider>
                    <Outlet></Outlet>
                </SoknaderProvider>

            </Container>

        </>
    );
}

export default Layout;